<!--
    描述：资源维护 --- 供应商维护
    时间：2026-02-04
    Created by yefan
-->
<template>
	<div class="operation-layout pd0">
		<!-- 列表查询页 -->
		<filter-layout @search="doSearch" @reset="doRefresh" hasMore>
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="140px">
					<el-form-item label="供应商名称：" prop="name">
						<el-input v-model="searchForm.name" placeholder="请输入" size="small"></el-input>
					</el-form-item>
					<el-form-item label="统一社会信用代码：" prop="creditCode">
						<el-input v-model="searchForm.creditCode" placeholder="请输入" size="small"></el-input>
					</el-form-item>
					<el-form-item label="供应商状态：" prop="status">
						<el-select v-model="searchForm.status" size="small">
							<el-option :value="0" label="暂停合作"></el-option>
							<el-option :value="1" label="正常"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="登记时间：" prop="dateArr">
						<el-date-picker
							v-model="searchForm.dateArr"
							type="daterange"
							clearable
							placeholder="请选择"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
				</el-form>
			</template>
			<template #more>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="140px">
					<el-form-item label="联系人：" prop="contact">
						<el-input v-model="searchForm.contact" placeholder="请输入" size="small"></el-input>
					</el-form-item>
					<el-form-item label="联系电话：" prop="contactPhone">
						<el-input v-model="searchForm.contactPhone" placeholder="请输入" size="small"></el-input>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							供应商合计：<span class="blue">{{ tableObj.total }}</span
							>个
						</div>
						<div class="btnGroups">
							<el-button class="btn-blue" size="small" @click="handleClick('add')">新增供应商</el-button>
						</div>
					</div>
					<div class="operation-container w-table-layout w-table-page">
						<div class="w-table-content" v-show="tableShow">
							<vxe-table
								ref="xTable"
								:data="tableObj.tableData"
								highlight-current-row
								highlight-hover-row
								align="center"
								border
								height="100%"
								size="small"
								auto-resize
								resizable
								show-overflow="tooltip"
								show-header-overflow="tooltip"
							>
								<vxe-table-column type="seq" title="序号" width="60px"></vxe-table-column>
								<vxe-table-column field="name" title="供应商名称" min-width="160px"></vxe-table-column>
								<vxe-table-column field="creditCode" title="统一社会信用代码" min-width="160px"></vxe-table-column>
								<vxe-table-column field="contactName" title="联系人" width="150px"></vxe-table-column>
								<vxe-table-column field="contactPhone" title="联系电话" width="150px"></vxe-table-column>
								<vxe-table-column field="goodsNum" title="供应商品数" width="150px"></vxe-table-column>
								<vxe-table-column field="status" title="供应商状态" width="150px">
									<template v-slot="{ row }">
										<span>{{ row.status == 1 ? '正常' : '暂停合作' }}</span>
									</template>
								</vxe-table-column>
								<vxe-table-column field="createDate" title="登记时间" width="150px"></vxe-table-column>
								<vxe-table-column title="操作" min-width="250px">
									<template v-slot="{ row }">
										<el-button
											class="table-btn"
											type="primary"
											round
											plain
											size="small"
											icon="el-icon-view"
											@click="handleClick('view', row)"
											>查看
										</el-button>
										<el-button class="table-btn" type="success" round plain size="small" @click="handleClick('edit', row)">
											<svg-icon icon-class="form-edit"></svg-icon>编辑
										</el-button>
										<el-button
											type="danger"
											size="small"
											round
											plain
											class="table-btn"
											icon="el-icon-delete"
											@click="handleClick('delete', row)"
											>删除
										</el-button>
									</template>
								</vxe-table-column>
							</vxe-table>
						</div>
						<div class="w-table-footer">
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="tableObj.currentPage"
								:page-size="tableObj.pageSize"
								:page-sizes="[10, 20, 50, 100]"
								layout="total, sizes, prev, pager, next, jumper"
								:total="tableObj.total"
							>
							</el-pagination>
						</div>
					</div>
				</div>
			</template>
		</filter-layout>

		<addSupplierDialog v-if="showSupplierDialog" ref="add_supplier_dialog" :showSupplierDialog.sync="showSupplierDialog" @doSuccess="doSuccess" />
	</div>
</template>

<script>
import addSupplierDialog from './components/add-supplier-dialog.vue'
import * as Api from '@/api/modules/supplierList.js'

export default {
	components: { addSupplierDialog },
	data() {
		return {
			searchToggle: true, // 切换展示 筛选条件
			tableShow: true, // 展示表格
			// 查询条件
			searchForm: {
				name: '', // 供应商名称
				creditCode: '', // 统一社会信用代码
				status: '', //供应商状态
				dateArr: [], // 登记时间
				contact: '', // 联系人
				contactPhone: '' // 联系电话
			},
			// 表格参数
			tableObj: {
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
			showSupplierDialog: false // 新增供应商弹框是否显示
		}
	},
	created() {
		this.doSearch()
	},
	methods: {
		// 获取表格数据
		getTableData() {
			let params = {
				current: this.tableObj.currentPage,
				size: this.tableObj.pageSize,
				...this.searchForm,
				createStartTime: this.searchForm.dateArr?.[0] || '',
				createEndTime: this.searchForm.dateArr?.[1] || ''
			}
			delete params.dateArr
			Api.selectSuppliersPage(params)
				.then((res) => {
					if (res.operationCode === 1) {
						this.tableObj.tableData = res.data.records
						this.tableObj.total = Number(res.data.total)
					}
				})
				.catch((err) => {})
		},

		// 查询
		doSearch(page) {
			this.tableObj.currentPage = 1
			this.getTableData()
		},

		// 点击刷新、重置
		doRefresh() {
			this.$refs.searchRef.resetFields()
			this.searchForm = {
				name: '', // 供应商名称
				creditCode: '', // 统一社会信用代码
				status: '', //供应商状态
				dateArr: [], // 登记时间
				contact: '', // 联系人
				contactPhone: '' // 联系电话
			}
			this.tableObj.pageSize = 10
			this.doSearch()
		},

		// 表格 每页条数切换
		handleSizeChange(size) {
			this.tableObj.pageSize = size
			this.doSearch()
		},

		// 表格 页码切换
		handleCurrentChange(cur) {
			this.tableObj.currentPage = cur
			this.doSearch()
		},

		// 表格操作按钮
		handleClick(type, row) {
			switch (type) {
				case 'add':
				case 'edit':
				case 'view':
					this.showSupplierDialog = true
					setTimeout(() => {
						this.$refs.add_supplier_dialog && this.$refs.add_supplier_dialog.open(type, row)
					}, 200)
					break
				case 'delete':
					this.$confirm('确认删除吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
						.then(() => {
							Api.delSuppliers({ id: row.id })
								.then((res) => {
									if (res.operationCode === 1) {
										this.$message({
											type: 'success',
											message: '删除成功!'
										})
										this.doSearch()
									} else {
										this.$message.warning(res.msg)
									}
								})
								.catch((err) => {})
						})
						.catch(() => {})
					break
				default:
					break
			}
		},

		// 弹框保存成功的回调
		doSuccess(type) {
			type === 'add' ? this.doSearch() : this.getTableData()
		}
	},
	computed: {},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		}
	}
}
</script>

<style scoped lang="less">
.left-btn {
	&::before {
		display: inline-block;
		content: '';
		width: 5px;
		height: 15px;
		background-color: #256ccb;
		position: relative;
		top: 3px;
		margin-right: 5px;
	}
}
</style>
